namespace Areas.Budget.Category {
    "use strict";

    let baseURL = "/Budget/Profile/InactivateBudgetAccountCategory";


    export function addBudgetCategory() {
        const budCatTree = $("#BudgetAccountCategoryTree").dxTreeList("instance");
        const selectedRows = budCatTree.getSelectedRowsData();

        if (selectedRows.length) {

            const parameters = {
                data: selectedRows[0],   
            };
            const createBudgetAccountCategoryDialog = new Areas.Dialogs.CreateBudgetAccountCategory.CreateBudgetAccountCategoryDialog(editDialogClosing, parameters);

        } else {
            let accountId = budCatTree.option("AccountId");

            const data = { accountId: accountId, budgetCategoryGroupLk: "P0" };
            const parameters = data;
            const createBudgetAccountCategoryDialog = new Areas.Dialogs.CreateBudgetAccountCategory.CreateBudgetAccountCategoryDialog(editDialogClosing, parameters);
        }


        

    }

    export function inActivateBudgetCategory() {
        const budCatTree = $("#BudgetAccountCategoryTree").dxTreeList("instance");
        const selectedRows = budCatTree.getSelectedRowsData();

        if (selectedRows.length) {

            selectedRows[0].isActive = false;
            let keyId = selectedRows[0].budgetAccountCategoryId;
            let newData = selectedRows[0];

            sendRequest(`${baseURL}/${keyId}`,
                JSON.stringify(newData),
                "PUT",
                () => {
                    Areas.reloadPage();
                });
        }
    }

    export function onTreeSelectionChanged(e: any) {
        let rowData: any = e.selectedRowsData[0];
        if (rowData.branchLevel == 1) {
            disableButton("CategoryEditButton");
            disableButton("CategoryDeleteButton");
        } else {
            enableButton("CategoryEditButton");
            enableButton("CategoryDeleteButton");
        }
    }

    export function editBudgetCategory() {
        const budCatTree = $("#BudgetAccountCategoryTree").dxTreeList("instance");
        const selectedRows = budCatTree.getSelectedRowsData();

        if (selectedRows.length) {

            const parameters = {
                data: selectedRows[0],
            };

            const editBudgetAccountCategoryDialog = new Areas.Dialogs.EditBudgetAccountCategory.EditBudgetAccountCategoryDialog(editDialogClosing, parameters);

        }
    }

    function editDialogClosing() {
        const budCatTree = $("#BudgetAccountCategoryTree").dxTreeList("instance");
        Areas.reloadPage();

    }

}
